module.exports = __webpack_public_path__ + "../css/f861240532f7decfdc35cc63dbdd8db6.svg";